import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { AuthShell, Field } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Forgot password?" subtitle="We'll email you a secure reset link">
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-sent">
          <div className="mx-auto h-12 w-12 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center mb-4">
            <MailCheck className="h-6 w-6 text-emerald-400" />
          </div>
          <p className="text-sm text-zinc-300 mb-1 font-semibold">Check your inbox</p>
          <p className="text-sm text-zinc-500">
            If an account exists for <span className="text-zinc-300">{email}</span>, a reset link is on its way. It expires in 60 minutes.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-md px-3 py-2" data-testid="forgot-error">{error}</p>}
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email" />
          <button disabled={loading} data-testid="forgot-submit" className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 py-2.5 rounded-md font-semibold transition-colors">
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
      <p className="text-sm text-zinc-500 mt-6 text-center">
        Remembered it? <Link to="/login" className="text-blue-400 hover:text-blue-300" data-testid="forgot-back-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
